import DOCUMENTS_SNAPSHOT from '../../../../rental-portal-mock-data/documents.json'
import USERS_SNAPSHOT from '../../../../rental-portal-mock-data/users.json'
import { HTTP_STATUS_INTERNAL_SERVER_ERROR } from '../../../constants/api'
import { EMPTY_LIST } from '../../../constants/common'
import {
  RENTAL_PORTAL_MOCK_LATENCY,
  RENTAL_PORTAL_MOCK_STATE,
} from '../../../constants/rentalPortalMockState'
import { toRentalPortalMockMediaUser } from '../../../utils/rentalPortalMockMedia'
import { hasRentalPortalMockState } from '../../../utils/rentalPortalMockState'

const MOCK_APPLICANT_DOCUMENTS_READ_LATENCY = 300

const MOCK_APPLICANT_DOCUMENTS_READ_ERROR = {
  response: { status: HTTP_STATUS_INTERNAL_SERVER_ERROR },
}

const MOCK_USER_BY_ID = new Map(
  USERS_SNAPSHOT.map(user => [user.id, toRentalPortalMockMediaUser(user)])
)

function toMockApplicantDocumentsById(documents) {
  return documents
    .filter(document => document.applicant_id)
    .sort((first, second) =>
      second.uploaded_at.localeCompare(first.uploaded_at)
    )
    .reduce((acc, document) => {
      const served = acc.get(document.applicant_id) ?? EMPTY_LIST

      return acc.set(document.applicant_id, [
        ...served,
        {
          ...document,
          uploaded_by:
            MOCK_USER_BY_ID.get(document.uploaded_by?.id) ??
            document.uploaded_by,
        },
      ])
    }, new Map())
}

const MOCK_APPLICANT_DOCUMENTS_BY_ID =
  toMockApplicantDocumentsById(DOCUMENTS_SNAPSHOT)

function withMockLatency() {
  const delay = hasRentalPortalMockState(RENTAL_PORTAL_MOCK_STATE.loading)
    ? RENTAL_PORTAL_MOCK_LATENCY
    : MOCK_APPLICANT_DOCUMENTS_READ_LATENCY

  return new Promise(resolve => {
    setTimeout(resolve, delay)
  })
}

export function getMockApplicantDocuments({
  applicant_id: applicantId,
  page,
  page_size: pageSize,
}) {
  return withMockLatency().then(() => {
    if (hasRentalPortalMockState(RENTAL_PORTAL_MOCK_STATE.error)) {
      return Promise.reject(MOCK_APPLICANT_DOCUMENTS_READ_ERROR)
    }

    const documents = hasRentalPortalMockState(RENTAL_PORTAL_MOCK_STATE.empty)
      ? EMPTY_LIST
      : (MOCK_APPLICANT_DOCUMENTS_BY_ID.get(Number(applicantId)) ?? EMPTY_LIST)

    const pageCount = Math.ceil(documents.length / pageSize)
    const currentPage = Math.min(page, Math.max(pageCount, 1))
    const firstIndex = (currentPage - 1) * pageSize

    return {
      data: {
        pagination: {
          page: currentPage,
          page_count: pageCount,
          total: documents.length,
        },
        results: {
          objects: documents.slice(firstIndex, firstIndex + pageSize),
        },
      },
    }
  })
}
